import { Pipe, PipeTransform } from '@angular/core';
import { keyBy } from 'lodash-es';

interface CheckboxFilterArg {
  id: number;
  label: string;
  value: boolean;
}

type CheckboxFilterValue = Record<string, string | null | undefined>;

@Pipe({
  name: 'CheckboxFilter',
  standalone: false,
})
/**
 * Arg should be an array of objects in this format
 *
 ts:
 checkboxes: any[] = [{
        id: 1,
        label: 'Filter 1',
        state: true
    }];

 forceUpdateCheckboxes(): void {
        if( this.checkboxes )
            this.checkboxes = this.checkboxes.slice();
    }

 html:

 <div class="btn-group">
 <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
 Filter
 </button>
 <div class="dropdown-menu">
 <span class="dropdown-item" *ngFor="let cb of checkboxes">
 <label>
 <input id="designationFilter{{cb.id}}" type="checkbox" [(ngModel)]="cb.value" (ngModelChange)="forceUpdateCheckboxes()"> {{cb.label}}
 </label>
 </span>
 </div>
 </div>

 */
export class CheckboxFilterPipe implements PipeTransform {
  transform(
    values: CheckboxFilterValue[],
    filterKey: string,
    args: CheckboxFilterArg[],
    equalsExact: boolean = false,
    blankText: string = '(Blank)'
  ): CheckboxFilterValue[] | undefined {
    if (values == null || values.length === 0 || args == null) return;
    return values.filter((value) => {
      for (let i = 0; i < args.length; i++) {
        const arg = args[i];
        if (arg['value'] === true && value[filterKey] !== undefined) {
          if (
            arg['label'] === blankText &&
            (value[filterKey] == null ||
              value[filterKey].toString().trim().length === 0)
          ) {
            return true;
          }
          if (
            value[filterKey] != null &&
            ((equalsExact && value[filterKey] === arg['label']) ||
              (!equalsExact && value[filterKey].indexOf(arg['label']) >= 0))
          ) {
            return true;
          }
        }
      }
      return false;
    });
  }

  createFilterItems(
    data: CheckboxFilterValue[],
    field: string,
    value: boolean = true,
    blankText: string = '(Blank)'
  ): CheckboxFilterArg[] {
    const temp = keyBy(data, field);
    const unique = Object.keys(temp);
    let checkboxes: CheckboxFilterArg[] = [];
    for (let i = 0; i < unique.length; i++) {
      const checkbox = {
        id: i,
        label:
          unique[i] === 'null' || unique[i].trim().length === 0
            ? blankText
            : unique[i],
        value: value,
      };
      checkboxes.push(checkbox);
    }
    checkboxes = checkboxes.sort((yin, yang) => {
      if (yin.label > yang.label) {
        return 1;
      }
      if (yin.label < yang.label) {
        return -1;
      }
      return 0;
    });
    return checkboxes;
  }
}
